export const CONNECT_METAMASK = 'CONNECT_METAMASK'
export const CONNECT_METAMASK_PASSIVE = 'CONNECT_METAMASK_PASSIVE'
export const METAMASK_CONNECTED = 'METAMASK_CONNECTED'

export const CONNECTION_CONNECTED = 'CONNECTION_CONNECTED'
export const CONNECTION_DISCONNECTED = 'CONNECTION_DISCONNECTED'

export const GET_BALANCES = 'GET_BALANCES'
export const BALANCES_RETURNED = 'BALANCES_RETURNED'

export const INVEST = 'INVEST'
export const INVEST_RETURNED = 'INVEST_RETURNED'

export const REDEEM = 'REDEEM'
export const REDEEM_RETURNED = 'REDEEM_RETURNED'

export const DONATE = 'DONATE'
export const DONATE_RETURNED = 'DONATE_RETURNED'

export const REBALANCE = 'REBALANCE'
export const REBALANCE_RETURNED = 'REBALANCE_RETURNED'

export const ERROR = 'ERROR'


export const GET_YIELD = 'GET_YIELD'
export const GET_YIELD_RETURNED = 'GET_YIELD_RETURNED'

export const GET_UNISWAP_YIELD = 'GET_UNISWAP_YIELD'
export const GET_UNISWAP_YIELD_RETURNED = 'GET_UNISWAP_YIELD_RETURNED'

export const GET_AGGREGATED_YIELD = 'GET_AGGREGATED_YIELD'
export const GET_AGGREGATED_YIELD_RETURNED = 'GET_AGGREGATED_YIELD_RETURNED'

export const GET_UNISWAP_COMPARRISONS = 'GET_UNISWAP_COMPARRISONS'
export const GET_UNISWAP_COMPARRISONS_RETURNED = 'GET_UNISWAP_COMPARRISONS_RETURNED'

export const GET_CONTRACT_EVENTS = 'GET_CONTRACT_EVENTS'
export const GET_CONTRACT_EVENTS_RETURNED = 'GET_CONTRACT_EVENTS_RETURNED'

export const CONNECT_LEDGER = 'CONNECT_LEDGER'
export const LEDGER_CONNECTED = 'LEDGER_CONNECTED'

export const ZAP = 'ZAP'
export const ZAP_RETURNED = 'ZAP_RETURNED'

export const IDAI = 'IDAI'
export const IDAI_RETURNED = 'IDAI_RETURNED'

export const SWAP = 'SWAP'
export const SWAP_RETURNED = 'SWAP_RETURNED'

export const TRADE = 'TRADE'
export const TRADE_RETURNED = 'TRADE_RETURNED'

export const GET_CURV_BALANCE = 'GET_CURV_BALANCE'
export const GET_CURV_BALANCE_RETURNED = 'GET_CURV_BALANCE_RETURNED'

export const INVEST_ALL = 'INVEST_ALL'
export const INVEST_ALL_RETURNED = 'INVEST_ALL_RETURNED'

export const BUY_INSURANCE = 'BUY_INSURANCE'
export const BUY_INSURANCE_RETURNED = 'BUY_INSURANCE_RETURNED'

export const CLAIM_INSURANCE = 'CLAIM_INSURANCE'
export const CLAIM_INSURANCE_RETURNED = 'CLAIM_INSURANCE_RETURNED'

export const MINT_INSURANCE = 'MINT_INSURANCE'
export const MINT_INSURANCE_RETURNED = 'MINT_INSURANCE_RETURNED'

export const GET_INSURANCE_BALANCES = 'GET_INSURANCE_BALANCES'
export const GET_INSURANCE_BALANCES_RETURNED = 'GET_INSURANCE_BALANCES_RETURNED'

export const CALCULATE_INSURANCE_COST = 'CALCULATE_INSURANCE_COST'
export const CALCULATE_INSURANCE_COST_RETURNED = 'CALCULATE_INSURANCE_COST_RETURNED'

export const GET_ETH_PRICE = 'GET_ETH_PRICE'
export const GET_ETH_PRICE_RETURNED = 'GET_ETH_PRICE_RETURNED'

export const GET_ETH_BALANCE = 'GET_ETH_BALANCE'
export const GET_ETH_BALANCE_RETURNED = 'GET_ETH_BALANCE_RETURNED'

export const CALCULATE_MAX_TOKENS = 'CALCULATE_MAX_TOKENS'
export const CALCULATE_MAX_TOKENS_RETURNED = 'CALCULATE_MAX_TOKENS_RETURNED'

export const GET_BEST_PRICE = 'GET_BEST_PRICE'
export const GET_BEST_PRICE_RETURNED = 'GET_BEST_PRICE_RETURNED'


export const GET_POOL_BALANCES = 'GET_POOL_BALANCES'
export const POOL_BALANCES_RETURNED = 'POOL_BALANCES_RETURNED'

export const DEPOSIT_POOL = 'DEPOSIT_POOL'
export const DEPOSIT_POOL_RETURNED = 'DEPOSIT_POOL_RETURNED'

export const DEPOSIT_ALL_POOL = 'DEPOSIT_ALL_POOL'
export const DEPOSIT_ALL_POOL_RETURNED = 'DEPOSIT_ALL_POOL_RETURNED'

export const WITHDRAW_POOL = 'WITHDRAW_POOL'
export const WITHDRAW_POOL_RETURNED = 'WITHDRAW_POOL_RETURNED'

export const WITHDRAW_ALL_POOL = 'WITHDRAW_ALL_POOL'
export const WITHDRAW_ALL_POOL_RETURNED = 'WITHDRAW_ALL_POOL_RETURNED'

export const EXCHANGE_POOL = 'EXCHANGE_POOL'
export const EXCHANGE_POOL_RETURNED = 'EXCHANGE_POOL_RETURNED'

export const GET_EXCHANGE_PRICE = 'GET_EXCHANGE_PRICE'
export const EXCHANGE_PRICE_RETURNED = 'EXCHANGE_PRICE_RETURNED'

export const GET_WITHDRAW_PRICE = 'GET_WITHDRAW_PRICE'
export const WITHDRAW_PRICE_RETURNED = 'WITHDRAW_PRICE_RETURNED'

export const GET_DEPOSIT_PRICE = 'GET_DEPOSIT_PRICE'
export const DEPOSIT_PRICE_RETURNED = 'DEPOSIT_PRICE_RETURNED'

export const GET_SPOOL_BALANCE = 'GET_SPOOL_BALANCE'
export const SPOOL_BALANCE_RETURNED = 'SPOOL_BALANCE_RETURNED'

export const GET_SPOOL_RATIO = 'GET_SPOOL_RATIO'
export const GET_SPOOL_RATIO_RETURNED = 'GET_SPOOL_RATIO_RETURNED'
